import * as _ from 'lodash';
import { CompositeModel } from './composite.model';
import { NumberModel } from '../primitive/number.model';
import { TextModel } from '../primitive/text.model';
import { ODataObject } from '../../interfaces/odata-model.interface';

export class DopModel extends CompositeModel {
    public poNum: NumberModel;
    public dropOffPoint: TextModel;
    public name1: TextModel;
    public name2: TextModel;
    public department: TextModel;
    public room: TextModel;
    public city: TextModel;
    public postalCode: TextModel;
    public street: TextModel;
    public additionalInfo: TextModel;
    public building: TextModel;
    public floor: TextModel;
    public state: TextModel;
    public phone: TextModel;
    public addrNumber: TextModel;
    public pos: NumberModel;
    public constructor(
        poNum = NaN,
        dropOffPoint = '',
        name1 = '',
        name2 = '',
        department = '',
        room = '',
        city = '',
        postalCode = '',
        street = '',
        additionalInfo = '',
        building = '',
        floor = '',
        state = '',
        telephone = '',
        addrNumber = '',
        pos = 0,
    ) {
        super('DopModel');
        this.poNum = new NumberModel('PONum', poNum);
        this.dropOffPoint = new TextModel('DropOfPoint', dropOffPoint);
        this.name1 = new TextModel('Name1', name1);
        this.name2 = new TextModel('Name2', name2);
        this.department = new TextModel('Department', department);
        this.room = new TextModel('Room', room);
        this.city = new TextModel('City', city);
        this.postalCode = new TextModel('PostCode', postalCode);
        this.street = new TextModel('Street', street);
        this.additionalInfo = new TextModel('AddInfo', additionalInfo);
        this.building = new TextModel('Building', building);
        this.floor = new TextModel('Floor', floor);
        this.state = new TextModel('State', state);
        this.phone = new TextModel('Phone', telephone);
        this.addrNumber = new TextModel('AddrNumber', addrNumber);
        this.pos = new NumberModel('Counter', pos);
    }

    public static compare(firstModel: DopModel, secondModel: DopModel): boolean {
        // TODO: Would it be enough to just compare this.dropOffPoint.value?
        return _.isEqual(firstModel, secondModel);
    }

    public static fromOData(dop: ODataDopModel): DopModel {
        return new DopModel(
            parseInt(dop.PONum, 10),
            dop.DropOfPoint,
            dop.Name1,
            dop.Name2,
            dop.Department,
            dop.Room,
            dop.City,
            dop.PostalCode,
            dop.Street,
            dop.AddInfo,
            dop.Building,
            dop.Floor,
            dop.State,
            dop.Telephone,
            dop.AddrNumber,
            parseInt(dop.Counter, 10),
        );
    }
}

export interface ODataDopModel extends ODataObject {
    PONum: string;
    DropOfPoint: string;
    Name1: string;
    Name2: string;
    Department: string;
    Room: string;
    City: string;
    PostalCode: string;
    Street: string;
    AddInfo: string;
    Building: string;
    Floor: string;
    State: string;
    Telephone: string;
    AddrNumber: string;
    Counter: string;
    NotificationNo: string;
    TaskNumber: string;
    __metadata: {
        uri: string;
        type: 'HC_SM_NGM_58_SRV.Dop';
    };
}
